<!-- default layout -->
<div *ngIf="layout=='default'" class="select-atm fd-select-ctn fd-input-ctn" [class.fd-invalid]="error">
  <div 
    class="fnd‐mdl‐dynamic‐textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select {{selector}} getmdl-select__fullwidth getmdl-select__fix-height padding-bottom-select-label"
    [class.is-invalid]="error">
    <input type="hidden" [(ngModel)]="value" [attr.name]="id" [id]="id">

    <input [value]="selectLabel" (click)="onDefaultToggle($event)" (focusout)="onDefaultFocusOut($event)"
      class="mdl-textfield__input" style="border-bottom-style: dashed; width: inherit;"
      [attr.disabled]="disabled ? 'disabled' : null" type="text" [hidden]="true" readonly>

    <a *ngIf="selectLabel" class="mdl-textfield__label dash-item-selected" (click)="onDefaultToggle($event)">
      <span>{{selectLabel}}</span>
    </a>

    <label>
      <i class="mdl-icon-toggle__label material-icons" (click)="onDefaultToggle($event)">keyboard_arrow_down</i>
    </label>

    <a class="mdl-textfield__label dash-item-selected" [attr.for]="selector"(click)="onDefaultToggle($event)">
      <span>{{label}}</span>
    </a>

    <ul class="mdl-menu mdl-menu--bottom-left mdl-js-menu" [attr.for]="selector">
      <li *ngFor="let option of options; let i=index"
        class="mdl-menu__item" [attr.data-val]="option.value" [ngClass]="{'active': selectedValue === option.label}"
        (blur)="onBlur($event.target.value)" (click)="onDefaultValueChange(option.label, i)">
        {{option.label}}
        <span class="fd-circular" *ngIf="selectedValue === option.label"><i class="material-icons">done</i></span>
      </li>
    </ul>
  </div>

  <span class="fd-hint">
    <span *ngIf="!error">{{hint}}</span>
    <span *ngIf="errorMessage">{{errorMessage}}</span>
    <ng-container *ngTemplateOutlet="validationContent"></ng-container>
  </span>
</div>

<!-- siff layout -->
<!--<div *ngIf="layout=='siff'" class="mdl-textfield sifflayout" [class.fd-invalid]="error" [class.is-invalid]="error">
    <label for="progetto">{{label}}</label>
    <div class="fd-sel">
      <a href="javascript:void(0);" (click)="onSiffOpen($event)" class="fd-sel-option-active">
        {{selectLabel}}
        <i class="material-icons fd-arrow">arrow_drop_down</i>
      </a>
      <div class="fd-sel-dropdown" [style.display]="open ? 'block' : 'none'">
        <ul>
          <li *ngFor="let group of options"><span>{{group.label}}</span>
            <ul>
              <li *ngFor="let item of group.values" (click)="onSiffValueChange(item)">
                <a href="javascript:void(0);" [class.active]="model==item.value">{{item.label}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="fd-select-ctn fd-input-ctn">
      <span class="fd-hint" [style.margin-top]="'7px'">
        <span *ngIf="!error">{{hint}}</span>
        <span *ngIf="errorMessage">{{errorMessage}}</span>
        <ng-container *ngTemplateOutlet="validationContent"></ng-container>
      </span>
    </div>
  </div> -->

<ng-template #validationContent>
  <ng-content select="fnd-validation"></ng-content>
</ng-template>